import React, { useState, useContext } from "react";
import "./reset.css";
import "./Login.css";
import { login } from "./functions";

import { Input } from "../../components/Input";
import ModalRedefinicaoSenha from "../../components/modais/ModalRedefinicaoSenha/ModalRedefinicaoSenha";
import { LoadingButton } from "../../components/loadingButtom";
import { Erro } from "../Cliente/AlteracaoSenha/AlteracaoSenha";

import { usuarioContext, UsuarioContextType } from "../../context/tipoUsuario";
import { AuthShell } from "../../components/AuthShell";

import { Link, useNavigate } from "react-router-dom";
import { handleReenviar } from "../Cliente/ConfirmacaoEmail/functions";

export interface Credenciais {
  email: string,
  senha: string,
  error?: boolean,
}

const Login = () => {
  const [credenciais, setCredenciais] = useState<Credenciais>({
    email: "",
    senha: "",
  });
  const [modalAlterarSenha, setModalAlterarSenha] = useState<boolean>(false);
  const [error, setError] = useState<Erro>({
    erro: false,
    mensagem: "",
  });
  const [loading, setLoading] = useState(false);
  const [botaoReenviarEmail, setBotaoReenviarEmail] = useState(false);
  const [reenviar, setReenviar] = useState<boolean>(false);
  const [erroReenviar, setErroReenviar] = useState<boolean>(false);

  const { atualizarUsuario, removerUsuario } = useContext<UsuarioContextType>(usuarioContext);
  const navigate = useNavigate();


  return (
    <AuthShell
      eyebrow="Omex Capital"
      title="Gestão do Cliente"
      subtitle="Acesse seu ambiente Omex para acompanhar operações, posições e solicitações com a velocidade que o mercado cripto exige."
      onLogoClick={() => navigate("/")}
    >
      <section className="auth-card login-auth-card" aria-labelledby="login-title">
        <div className="auth-card-header">
          <p className="auth-card-kicker">Acesso seguro</p>
          <h2 className="auth-card-title" id="login-title">Entrar na plataforma</h2>
          <p className="auth-card-copy">Use suas credenciais para continuar.</p>
        </div>

        <form
          onSubmit={(e) => login(
            e,
            setLoading,
            setBotaoReenviarEmail,
            setCredenciais,
            credenciais,
            navigate,
            removerUsuario,
            atualizarUsuario,
            setError,
          )}
          className="container-form"
        >
          <Input
            type="email"
            label="E-mail"
            placeholder=" "
            autoComplete="email"
            value={credenciais.email}
            onChange={(e) => {
              setCredenciais({
                ...credenciais,
                email: e.target.value,
              });
            }}
          />
          <Input
            type="password"
            label="Senha"
            placeholder=" "
            senha
            required
            autoComplete="current-password"
            value={credenciais.senha}
            onChange={(e) => {
              setCredenciais({
                ...credenciais,
                senha: e.target.value,
              });
            }}
          />
          <div className="AreaLogin_Botao">
            {loading ? (
              <LoadingButton />
            ) : (
              <button
                className="auth-primary-button botaoLogin"
                type="submit"
              >
                Entrar
              </button>
            )}
            {error.erro && (
              <p className="auth-message">{error.mensagem}</p>
            )}
            {botaoReenviarEmail && (
              erroReenviar ?
                <p className="auth-message">Erro ao reenviar o email. Tente novamente mais tarde.</p>
                :
                reenviar ?
                  <p className="auth-message success">Email reenviado com sucesso.</p>
                  :
                  <button
                    className="auth-text-button"
                    type="button"
                    onClick={() => handleReenviar(credenciais.email, "2", setReenviar, setErroReenviar)}
                  >
                    Reenviar email de confirmação
                  </button>
            )}
          </div>

          <div className="auth-link-row Area_EsqueceuSenha">
            <div className="AlterarSenha">
              <p>Esqueceu a senha?</p>
              <button
                className="auth-text-button btnAlterarSenha"
                type="button"
                onClick={() => setModalAlterarSenha(true)}
              >
                Recuperar acesso
              </button>
            </div>
            <div className="AbrirConta">
              <p>Ainda não tem conta?</p>
              <Link to="/cliente/cadastro">Abra uma conta</Link>
            </div>
          </div>
        </form>

        <ModalRedefinicaoSenha
          mostrar={modalAlterarSenha}
          fecharModal={() => setModalAlterarSenha(false)}
        />
      </section>
    </AuthShell>
  );
};

export default Login;
